import axios from 'axios';
import type { GroupInfo } from '../../Router/pages/ManageUsersPage/Hooks';

interface GroupInfoToSave extends Omit<Partial<GroupInfo>, 'users'> {
  users: string[];
}

const save = async (info: GroupInfoToSave) => axios.post(`/group`, info);

export default save;
